import { render, staticRenderFns } from "./Straps.vue?vue&type=template&id=3f9a9a0c&"
import script from "./Straps.vue?vue&type=script&lang=js&"
export * from "./Straps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports